"use client";

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';
interface TextWithBigImageAndIconProps {
  text?: string;
  imageSrc?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  /** Hero image metadata with focus-point for object-position */
  imageMetadata?: ImageMetadata;
  /** Use fixed height container for hero images */
  fixedHeight?: boolean;
}

// Tiny 1x1 gray placeholder for blur effect (base64 encoded)
const BLUR_DATA_URL = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBEQCEAwEPwAB//9k=";
export default function ImageWithText(t0) {
  const $ = _c(16);
  const {
    text,
    imageSrc,
    priority: t1,
    imageMetadata,
    fixedHeight: t2
  } = t0;
  const priority = t1 === undefined ? false : t1;
  const fixedHeight = t2 === undefined ? false : t2;
  const validImageSrc = imageSrc && imageSrc.trim() !== "" ? imageSrc : "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png";
  const t3 = `relative w-full ${fixedHeight ? "aspect-[16/9] max-h-[475px] overflow-hidden" : ""}`;
  const t4 = text || "News image";
  const t5 = `w-full ${fixedHeight ? "h-full" : "h-auto"} object-cover`;
  let t6;
  if ($[0] !== imageMetadata) {
    t6 = getFocusPointStyle(imageMetadata);
    $[0] = imageMetadata;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = priority ? "eager" : "lazy";
  const t8 = priority ? "high" : "auto";
  let t9;
  if ($[2] !== priority || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8 || $[8] !== validImageSrc) {
    t9 = <Image src={validImageSrc} alt={t4} width={800} height={450} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1250px) 50vw, 33vw" className={t5} style={t6} loading={t7} fetchPriority={t8} placeholder="blur" blurDataURL={BLUR_DATA_URL} />;
    $[2] = priority;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = validImageSrc;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== text) {
    t10 = text && <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-FFFFFF p-2 sm:p-3 md:p-4"><p className="text-start text-14-tamil-600 text-FFFFFF line-clamp-1 leading-[1.4]">{text}</p></div>;
    $[10] = text;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t3 || $[14] !== t9) {
    t11 = <div className={t3}>{t9}{t10}</div>;
    $[12] = t10;
    $[13] = t3;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}